
const SectionWideWithImage = () => {
	return (
		<div>b</div>
	);
};

export default SectionWideWithImage;
